import { getToken } from '@optimus-web/common';
import { BannerVariant } from './types';

export const getBannerBackgroundColor = (variant: BannerVariant) => {
    switch (variant) {
        case 'error':
            return getToken('backgroundAlertDangerSecondary');
        case 'info':
            return getToken('backgroundAlertInfoSecondary');
        case 'success':
            return getToken('backgroundAlertSuccessSecondary');
        case 'warning':
            return getToken('backgroundAlertWarningSecondary');
    }
};

export const getBannerColor = (variant: BannerVariant) => {
    switch (variant) {
        case 'error':
            return getToken('textAlertDanger');
        case 'info':
            return getToken('textAlertInfo');
        case 'success':
            return getToken('textAlertSuccess');
        case 'warning':
            return getToken('textAlertWarning');
    }
};
